import { useCallback, useRef, useState } from "react";

import { useRequestCesSurveyMutation } from "@/data/mutations/cesSurveysMutations";
import { CesSurveyTriggerPointType } from "@/domain/cesSurveys";

export const useCesSurvey = ({
  triggerPoint,
}: {
  triggerPoint: CesSurveyTriggerPointType;
}) => {
  const [cesSurveyId, setCesSurveyId] = useState<string | null>(null);
  const onContinueRef = useRef<(() => void) | null>(null);

  const { mutate: requestCesSurvey } = useRequestCesSurveyMutation();

  // The survey never blocks the flow: a patient who is not sampled, and any
  // failed request, continues straight away
  const showCesSurveyThenContinue = (onContinue: () => void) => {
    requestCesSurvey(
      { triggerPoint },
      {
        onSuccess: cesSurvey => {
          if (!cesSurvey) {
            onContinue();
            return;
          }

          onContinueRef.current = onContinue;
          setCesSurveyId(cesSurvey.id);
        },
        onError: onContinue,
      },
    );
  };

  const handleCompleted = useCallback(() => {
    setCesSurveyId(null);
    onContinueRef.current?.();
    onContinueRef.current = null;
  }, []);

  return {
    showCesSurveyThenContinue,
    cesSurveyProps: {
      cesSurveyId,
      triggerPoint,
      onCompleted: handleCompleted,
    },
  };
};
